import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as productCallsActionCreators from '../../../../actionCreators/product';
import { loadDittoShare, setDittoShareFromStorage } from '../../../../actionCreators/dittoShare';
import getSetCookie from '../../../../cookie';
import localStorageHelper from '../../../../utils/localStorageHelper';
import config from 'config';
import './DittoShare.scss';
import BootstrapSuccessError from '../../BootstrapSuccessError/BootstrapSuccessError';
// import Loader from '../../../../CommonComponents/Loader/Loader';

class DittoShare extends PureComponent {
  constructor(props) {
    super(props);
    this.isBrowserSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.timer = null;
    this.state = {
      dittoShareCopyMsg: '',
      mailPopup: false,
      serverErr: '',
      dittoEmailSuccess: false,
    };
  }

  componentDidMount() {
    this.getDittoImage(this.props.productData.id);
    if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Pdp.load.howDoILook();
    let fbRoot = document.getElementById('fb-root');
    if (!fbRoot) {
      fbRoot = document.createElement('div');
      fbRoot.id = 'fb-root';
      document.body.appendChild(fbRoot);

      window.fbAsyncInit = () => {
        window.FB.init({
          version: 'v2.8',
          appId: '1539126669661542',
          xfbml: true,
          cookie: true,
          status: true,
        });
      };
    }
    if (!window.FB) {
      ((doc, id) => {
        if (doc.getElementById(id)) return;
        const fbScript = doc.createElement('script');
        fbScript.id = id;
        fbScript.src = '//connect.facebook.net/en_US/all.js';
        doc.body.appendChild(fbScript);
      })(document, 'facebook-jssdk');
    }
  }

  componentDidUpdate(prevProps) {
    const { dittoShareCopyMsg } = this.state;
    const {
      dittoShareData,
      productData,
      selectedDittoId,
      headturnVisible,
      dittoAuth,
      showEmailPopUp,
      productCallsAction,
      dittoEmailSuccess,
    } = this.props;
    const productDataId = productData.id;
    const dittoId = getSetCookie.getCookie('isDittoID');
    if (prevProps.dittoEmailSuccess !== dittoEmailSuccess && dittoEmailSuccess === false) {
      this.showServerError();
    }
    if (dittoEmailSuccess) {
      (() => {
        this.setState({ dittoEmailSuccess: true, emailErr: false, serverErr: false });
      })();
      this.timer = setTimeout(() => {
        productCallsAction.dittoImgEmailReset();
        showEmailPopUp(false);
        this.setState({ dittoEmailSuccess: false, mailPopup: false });
      }, 2000);
    }
    if (
      prevProps.selectedDittoId !== selectedDittoId ||
      (headturnVisible && dittoShareCopyMsg !== '')
    ) {
      showEmailPopUp(false);
      (() => {
        this.setState({ dittoShareCopyMsg: '', mailPopup: false });
      })();
    }
    if (
      prevProps.dittoShareData !== dittoShareData &&
      dittoShareData &&
      dittoShareData.fileLocation &&
      dittoShareData.setLocalStorage !== false
    ) {
      const { fileLocation } = dittoShareData;
      const dittoShare = localStorageHelper.getItem('dittoShare') || {};
      const fileLocationArr = fileLocation.split('/');
      dittoShare[`${productDataId}_${dittoId}`] = config.ditto.replaceShareDittoUrlPrefix
        ? `https://static6.lenskart.com/${fileLocationArr[fileLocationArr.length - 1]}`
        : fileLocation;
      localStorageHelper.setItem('dittoShare', dittoShare);
    }
    if (
      prevProps?.dittoAuth?.result?.signature &&
      prevProps?.dittoAuth?.result?.signature !== dittoAuth?.result?.signature
    ) {
      this.getDittoImage(productDataId, true);
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.timer);
  }
  getDittoImage(sku, bypass) {
    const { loadDittoShare, setDittoShareFromStorage, redisCommonData, overlayedDittoData } =
      this.props;
    const productDataId = sku;
    const dittoId = getSetCookie.getCookie('isDittoID');
    if (!redisCommonData?.ENABLE_CYGNUS && dittoId) {
      const dittoLocalKey = `${productDataId}_${dittoId}`;
      const dittoShare = localStorageHelper.getItem('dittoShare') || {};
      const fileLocation = dittoShare[dittoLocalKey];
      if (!fileLocation || bypass) {
        const dittoAccessID = getSetCookie.getCookie('dittoAccessID');
        const dittoSignature = getSetCookie.getCookie('dittoSignature');
        fetch(`${config.ditto.vtoUrl}${dittoId}/frontal-frame/?product_id=${sku}`, {
          headers: {
            'X-Ditto-Access-Key-Id': dittoAccessID,
            'X-Ditto-Signature': dittoSignature,
          },
        })
          .then(res => {
            return res.blob();
          })
          .then(blob => {
            const fileType = '.' + blob.type.split('/')[1];
            const formData = new FormData();
            const file = new File([blob], dittoId + fileType, { lastModified: new Date() });
            formData.append('file', file);
            loadDittoShare(dittoId, formData);
          });
      } else {
        setDittoShareFromStorage(fileLocation);
      }
    }
    if (redisCommonData?.ENABLE_CYGNUS && overlayedDittoData) {
      (async () => {
        const response = await fetch(overlayedDittoData?.overlayed_image_url);
        const blob = await response.blob();
        const fileType = '.' + blob.type.split('/')[1];
        const formData = new FormData();
        const file = new File([blob], dittoId + fileType, { lastModified: new Date() });
        formData.append('file', file);
        loadDittoShare(dittoId, formData);
      })();
    }
  }

  showServerError = () => {
    const { showEmailPopUp, productCallsAction } = this.props;
    showEmailPopUp(true);
    this.setState({ mailPopup: true, emailErr: false, serverErr: true });
    this.timer = setTimeout(() => {
      productCallsAction.dittoImgEmailReset();
      this.setState({ emailErr: false, serverErr: false });
    }, 2000);
  };

  copyButton = () => {
    const { productLinkCopiedText, copyNotSupportedText, showEmailPopUp } = this.props;
    const copyTextarea = document.querySelector('.dittoShare_options_dittoUrl');
    copyTextarea.select();
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? productLinkCopiedText : copyNotSupportedText;
      showEmailPopUp(false);
      this.setState({ mailPopup: false, dittoShareCopyMsg: msg });
    } catch (err) {
      showEmailPopUp(false);
      this.setState({ mailPopup: false, dittoShareCopyMsg: copyNotSupportedText });
    }
  };

  sharingDitto = {
    facebookShare: dittoSaveUrl => {
      const urlToShare = encodeURIComponent(dittoSaveUrl);
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' +
          urlToShare +
          '&cmpid=product.share.pp&quote=How do these glasses look on me? Just tried them using 3D Try On. Its super cool - See for yourself on lenskart.com!',
        'sharer',
        'width=626,height=436'
      );
      _gaq.push(
        ['_trackEvent', 'Ditto', `Facebook_ ${location}`, `page: ${document.location.href}`],
        ['ninja._trackEvent', 'Ditto', `Facebook_ ${location}`, `page: ${document.location.href}`]
      );
      this.setState({ dittoShareCopyMsg: '' });
    },
    twitterShare: dittoSaveUrl => {
      const tweetText = `Check out my new frames from https://www.lenskart.com . How do I look?! ${dittoSaveUrl}`;
      window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(tweetText));
      _gaq.push(
        ['_trackEvent', 'Ditto', `Twitter_ ${location}`, `page: ${document.location.href}`],
        ['ninja._trackEvent', 'Ditto', `Twitter_ ${location}`, `page: ${document.location.href}`]
      );
      this.setState({ dittoShareCopyMsg: '' });
    },
    pinterestShare: dittoSaveUrl => {
      const pinURL = `https://www.pinterest.com/pin/create/button/?guid=kn05Ehp_iTMM-1&amp;url=${document.location.href}&amp;media=${dittoSaveUrl}`;
      window.open(pinURL);
    },
  };

  emailDitto = (evt, dittoSaveUrl) => {
    const { productCallsAction, showEmailPopUp } = this.props;
    this.setState({ dittoShareCopyMsg: '' });
    if (this.state.mailPopup && this.validateEmailID(this.refs.dittoemail.value)) {
      productCallsAction.sendDittoImageEmail({
        toemail: this.refs.dittoemail.value,
        subject: 'Your 3D TryOn Image-Lenskart',
        htmlbody: dittoSaveUrl,
      });
      // this.setState({ mailPopup: false, emailErr: false });
      // showEmailPopUp(false);
    } else {
      this.setState({ mailPopup: true, emailErr: true });
      showEmailPopUp(true);
    }
    if (evt === 'open') {
      this.setState({ mailPopup: true, emailErr: false });
      showEmailPopUp(true);
    }
  };

  validateEmailID = email => {
    const emailRegex =
      /^[-a-z0-9~!$^&*_=+}{\'?]+(\.[-a-z0-9~!$^&*_=+}{\'?]+)*@([a-z0-9][-a-z0-9]*(\.[-a-z0-9]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    return emailRegex.test(email);
  };

  createModal(body) {
    return <div>{body}</div>;
  }

  render() {
    const { dittoShareData, dittoShareLoading, headturnVisible, dataLocale } = this.props;
    const {
      ENTER_EMAIL_ID,
      SEND_IMAGE,
      SHARE_VIA_EMAIL,
      PLEASE_ENTER_A_VALID_EMAIL_ADDRESS,
      SOMETHING_HAS_GONE_WRONG_PLEASE_TRY_AGAIN,
      OOPS_SOMETHING_WENT_WRONG,
      EMAIL_IS_SUCCESSFULLY_SEND,
      LINK_COPIED,
      FACEBOOK,
      TWITTER,
      GMAIL,
      COPY,
    } = dataLocale;
    const { dittoEmailSuccess } = this.state;
    // if (dittoShareLoading) { return this.createModal('Creating secure sharable link', <div className="text-center"><Loader /></div>); }
    let dittoSaveUrl;
    if (dittoShareData && dittoShareData.fileLocation) {
      const { fileLocation } = dittoShareData;
      const fileLocationArr = fileLocation.split('/');
      dittoSaveUrl = config.ditto.replaceShareDittoUrlPrefix
        ? `https://static6.lenskart.com/${fileLocationArr[fileLocationArr.length - 1]}`
        : fileLocation;
    }
    return (
      <React.Fragment>
        {dittoSaveUrl || dittoShareLoading ? (
          <div>
            <div className="dittoShare_options">
              <div
                className={`dittoShare_options_action ${
                  dittoShareLoading || headturnVisible ? 'disabled-share-icon' : ''
                }`}
                onClick={() => this.sharingDitto.facebookShare(dittoSaveUrl)}
              >
                <img
                  alt={FACEBOOK}
                  className="share-ditto padding-5"
                  src="//static.lenskart.com/media/desktop/img/pdp/facebook.png"
                />
                {/* <div className="dittoShare_options_text">Facebook</div> */}
              </div>
              <div
                className={`dittoShare_options_action ${
                  dittoShareLoading || headturnVisible ? 'disabled-share-icon' : ''
                }`}
                onClick={() => this.sharingDitto.twitterShare(dittoSaveUrl)}
              >
                <img
                  alt={TWITTER}
                  className="share-ditto-twttr padding-5"
                  src="//static.lenskart.com/media/desktop/img/pdp/twitter.png"
                />
                {/* <div className="dittoShare_options_text">Twitter</div> */}
              </div>
              <div
                className={`dittoShare_options_action ${
                  dittoShareLoading || headturnVisible ? 'disabled-share-icon' : ''
                }`}
                onClick={() => this.emailDitto('open')}
              >
                <img
                  alt={GMAIL}
                  className="share-ditto-email padding-5"
                  src="//static.lenskart.com/media/desktop/img/pdp/gmail.png"
                />
                {/* <div className="dittoShare_options_text">Gmail</div> */}
              </div>
              {!this.isBrowserSafari && (
                <div className="dittoShare_options_action">
                  <button
                    className={`dittoShare_options_dittoUrlBtn padding-5 ${
                      dittoShareLoading || headturnVisible ? 'disabled-share-icon' : ''
                    }`}
                    onClick={() => this.copyButton()}
                  >
                    <img
                      alt={COPY}
                      src="//static.lenskart.com/media/desktop/img/pdp/share_link.png"
                    />
                  </button>
                  <input
                    className="dittoShare_options_dittoUrl"
                    defaultValue={dittoSaveUrl}
                    id="dittoUrl"
                  />
                  {/* <div className="dittoShare_options_text">Copy Link</div> */}
                </div>
              )}
              {this.state.dittoShareCopyMsg && <div className="copy_msg">{LINK_COPIED}</div>}
            </div>
            {this.state.mailPopup === true ? (
              <div className="dittoShare_emailPopup">
                {dittoEmailSuccess && (
                  <BootstrapSuccessError message={EMAIL_IS_SUCCESSFULLY_SEND} type="success" />
                )}
                <h4 className="fs16 text-33 fw700 text-left">{SHARE_VIA_EMAIL}</h4>
                <div className="display-flex" id="mail_pop">
                  <input
                    ref="dittoemail"
                    className="input-field dittoShare_emailPopup_validateEmail"
                    placeholder={ENTER_EMAIL_ID}
                    style={{ flexGrow: 1 }}
                    type="text"
                  />
                  <input
                    className="btn btn-main margin-l20"
                    id="submitBtn"
                    type="button"
                    value={SEND_IMAGE}
                    onClick={() => this.emailDitto('close', dittoSaveUrl)}
                  />
                </div>
                {(this.state.emailErr || this.state.serverErr) && (
                  <div className="dittoShare_emailPopup_error alert-danger text-left">
                    {this.state.emailErr
                      ? PLEASE_ENTER_A_VALID_EMAIL_ADDRESS
                      : SOMETHING_HAS_GONE_WRONG_PLEASE_TRY_AGAIN}
                  </div>
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        ) : (
          this.createModal(
            'Unable to create link',
            <div className="dittoShare_msg">{OOPS_SOMETHING_WENT_WRONG}</div>
          )
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dittoEmailSuccess: state.product.dittoEmailSuccess,
  dittoShareData: state.dittoShare.dittoShareData,
  dittoShareLoading: state.dittoShare.dittoShareLoading,
  dittoAuth: state.common.dittoAuth,
  dataLocale: state.locale,
  overlayedDittoData: state.ditto.overlayedDittoData,
  redisCommonData: state.common.redisCommonData,
});

function mapDispatchToProps(dispatch) {
  return {
    productCallsAction: bindActionCreators(productCallsActionCreators, dispatch),
    loadDittoShare: (dittoId, formData) => dispatch(loadDittoShare(dittoId, formData)),
    setDittoShareFromStorage: fileLocation => dispatch(setDittoShareFromStorage(fileLocation)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DittoShare);
